import {css} from 'lit';

export const fontFaces = css`
	:host {
		@font-face {
			font-family: 'Lineto Brown Pro Light';
			src: url('../fonts/lineto-brown-pro-light.woff2') format('woff2'),
			url('../fonts/lineto-brown-pro-light.woff') format('woff');
			font-style: normal;
			font-weight: normal;
		}

		@font-face {
			font-family: 'Lineto Brown Pro Regular';
			src: url('../fonts/lineto-brown-pro-regular.woff2') format('woff2'),
			url('../fonts/lineto-brown-pro-regular.woff') format('woff');
			font-style: normal;
			font-weight: normal;
		}

		@font-face {
			font-family: 'Lineto Brown Pro Bold';
			src: url('../fonts/lineto-brown-pro-regular.woff2') format('woff2'),
			url('../fonts/lineto-brown-pro-regular.woff') format('woff');
			font-style: normal;
			font-weight: 700;
		}

		@font-face {
			font-family: "BrownMonoLLWeb-Regular";
			src: url("../fonts/BrownMonoLLWeb-Regular.woff2") format("woff2"), url('../fonts/BrownMonoLLWeb-Regular.woff') format('woff');
			font-weight: 500;
		}
	}
`;

export const fonts = css`
	:host {
		--font-big-title: 300 72px "Lineto Brown Pro Light", sans-serif;
		--font-small-title: 300 51px "Lineto Brown Pro Light", sans-serif;
		--font-modal-title: 300 27px "Lineto Brown Pro Light", sans-serif;
		--font-modal-title-bold: 400 27px "Lineto Brown Pro Bold", sans-serif;
		--font-modal-title-regular: 400 27px "Lineto Brown Pro Regular", sans-serif;
		--font-info-light: 300 19px "Lineto Brown Pro Light", sans-serif;
		--font-light: 300 14px "Lineto Brown Pro Light", sans-serif;
		--font-bold: 700 14px "Lineto Brown Pro Bold", sans-serif;
		--font-summary-paragraph: 300 15px "Lineto Brown Pro Light", sans-serif;
		--font-summary-table: 300 13px "Lineto Brown Pro Light", sans-serif;
		--font-mobile-title: 300 35px "Lineto Brown Pro Light", sans-serif;
		--font-section-title: 300 19px "Lineto Brown Pro Light", sans-serif;
		--font-section-title-regular: 400 19px "Lineto Brown Pro Regular", sans-serif;
		--font-section-label: 300 13px "Lineto Brown Pro Regular", sans-serif;
		--font-info-small: 300 11px "Lineto Brown Pro Light", sans-serif;

		--font-downloads-title: 300 27px "Lineto Brown Pro Light", sans-serif;
		--font-downloads-description: 300 19px "Lineto Brown Pro Light", sans-serif;


		--font-family-light: "Lineto Brown Pro Light";
		--font-family-bold: "Lineto Brown Pro Bold";
		--font-family-regular: "Lineto Brown Pro Regular";
		--font-family-monospace: "BrownMonoLLWeb-Regular", monospace;

		--font-specsheet-title: 700 27px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-bold: 700 15px "Lineto Brown Pro Bold", sans-serif;
		--font-specsheet-light: 300 15px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-sectiontitle: 300 16px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-small-bold: 700 10px "Lineto Brown Pro Bold", sans-serif;
		--font-specsheet-small-light: 300 10px "Lineto Brown Pro Light", sans-serif;

		--font-specsheet-print-title: 300 18px "Lineto Brown Pro Bold", sans-serif;
		--font-specsheet-print-title-bold: 700 18px "Lineto Brown Pro Bold", sans-serif;
		--font-specsheet-print-bold: 700 10px "Lineto Brown Pro Bold", sans-serif;
		--font-specsheet-print-light: 300 10px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-print-sectiontitle: 300 11pt "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-print-small-bold: 700 7pt "Lineto Brown Pro Bold", sans-serif;
		--font-specsheet-print-small-light: 300 7pt "Lineto Brown Pro Light", sans-serif;

		--font-specsheet-headline: 300 24px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-print-headline: 300 18px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-small-text: 300 15px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-print-small-text: 300 8px "Lineto Brown Pro Light", sans-serif;
		--font-specsheet-print-small-bold-text: 300 8px "Lineto Brown Pro Bold", sans-serif;


		--font-widget-title: 500 13px "Lineto Brown Pro Regular", sans-serif;
		--font-widget-big-title: 300 27px "Lineto Brown Pro Light", sans-serif;
		--font-widget-small-title: 300 15px "Lineto Brown Pro Light", sans-serif;
		--font-widget-label: 500 13px "Lineto Brown Pro Light", sans-serif;
		--font-widget-big-label: 500 15px "Lineto Brown Pro Regular", sans-serif;
		--font-widget-info: 300 13px "Lineto Brown Pro Light", sans-serif;

		--font-solar-assembly-title: 500 19px "Lineto Brown Pro Regular", sans-serif;

	}
`;
export const staggeredReveal = css`
	:host {
		opacity: 0;
		animation: reveal 0.25s ease-out 0.5s 1 normal forwards;
	}

	:host(:nth-child(0)) {
		animation-delay: 0s
	}

	:host(:nth-child(1)) {
		animation-delay: 0.05s
	}

	:host(:nth-child(2)) {
		animation-delay: 0.1s
	}

	:host(:nth-child(3)) {
		animation-delay: 0.15s
	}

	:host(:nth-child(4)) {
		animation-delay: 0.2s
	}

	:host(:nth-child(5)) {
		animation-delay: 0.25s
	}

	:host(:nth-child(6)) {
		animation-delay: 0.3s
	}

	:host(:nth-child(7)) {
		animation-delay: 0.35s
	}

	:host(:nth-child(8)) {
		animation-delay: 0.4s
	}

	:host(:nth-child(9)) {
		animation-delay: 0.43s
	}

	:host(:nth-child(10)) {
		animation-delay: 0.46s
	}

	:host(:nth-child(11)) {
		animation-delay: 0.48s
	}

	:host(:nth-child(12)) {
		animation-delay: 0.5s
	}

	@keyframes reveal {
		from {
			opacity: 0;
			margin-top: -10px;
		}

		to {
			opacity: 100%;
			margin-top: 0px;
		}
	}
`;

export const widgetButton = css`
	button {
		width: 100%;
		font: var(--font-widget-label);
		color: var(--color-widget-text);
		background-color: transparent;
		display: inline-block;
		height: var(--height-widget);
		min-width: var(--height-widget);
		cursor: pointer;
		white-space: nowrap;
		transition: background-color 0.4s, color 0.4s;
		padding: 8px 16px;
		text-align: center;
		border: 0 none;
		overflow: hidden;
		box-shadow: 1px 0 0 0 var(--color-widget-border),
		0 1px 0 0 var(--color-widget-border),
		1px 1px 0 0 var(--color-widget-border),
		1px 0 0 0 var(--color-widget-border) inset,
		0 1px 0 0 var(--color-widget-border) inset;
	}

	button:hover {
		background-color: var(--color-widget-background-hover);
	}

	.selected button {
		background-color: var(--color-widget-background-selected);
	}

	.fixed button {
		pointer-events: none;
		// background-color: var(--color-widget-background-implicit);
	}

	.implicit button {
		background-color: var(--color-widget-background-implicit);
	}

	.disabled button {
		color: var(--color-widget-border);
	}

	.disabled button:hover {
		color: var(--color-widget-border);
	}

	.disabledAndSelected button {
		background-color: var(--color-widget-background-selected);
		color: var(--color-widget-background);
	}

`;

export const hoverInfo = css`
	.hoverinfo {
		transition: left 0.25s ease-out, opacity 0.25s ease-out;
		transform: translateY(-50%);
		display: block;
		opacity: 0;
		pointer-events: none;
		position: absolute;
		top: 18px;
		left: calc(100% + 25px);
		z-index: 10;
		margin: 0 auto;
		width: 200px;
	}

	.item:hover .hoverinfo {
		display: block;
		opacity: 1;
		left: calc(100% + 5px);
		transition-delay: 1.5s;
	}

	.hoverinfo .content {
		position: relative;
		border: 1px solid;
		border-color: var(--color-widget-border);
		padding: 0.5em 1em;
		background-color: var(--color-black);
		font: var(--font-widget-label);
		color: var(--color-white);
	}

	.hoverinfo .content:after {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 0;
		height: 0;
		border: 10px solid transparent;
		border-right-color: #000000;
		border-left: 0;
		margin-top: -10px;
		margin-left: -10px;
	}

	.hoverinfo .content:before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 0;
		height: 0;
		border: 12px solid transparent;
		border-right-color: var(--border-widget);
		border-left: 0;
		margin-top: -12px;
		margin-left: -12px;
	}
`;

export const inputRange = css`
	input[type=range] {
		-webkit-appearance: none;
		margin: 0;
		width: 100%;
		background: transparent;
		height: 0;
	}

	input[type=range]:focus {
		outline: none;
	}

	input[type=range]::-webkit-slider-runnable-track {
		width: 100%;
		height: 0;
		cursor: pointer;
		background: var(--color-widget-border);
		border: 0 none;
	}

	input[type=range]::-webkit-slider-thumb {
		-webkit-appearance: none;
		border: 1px solid var(--color-widget-border);
		height: 20px;
		width: 20px;
		border-radius: 10px;
		background: var(--color-widget-border);
		cursor: pointer;
		margin-top: -10px;
	}

	input[type=range]:focus::-webkit-slider-runnable-track {
		background: var(--color-widget-border);
	}

	input[type=range]::-moz-range-track {
		width: 100%;
		height: 0;
		cursor: pointer;
		background: var(--color-widget-border);
		border: 0 none;
	}

	input[type=range]::-moz-range-thumb {
		border: 1px solid var(--color-widget-border);
		height: 20px;
		width: 20px;
		border-radius: 10px;
		background: var(--color-widget-border);
		cursor: pointer;
		margin-top: -10px;
	}
`;

export const colorThemes = css`
	.darkTheme {
		--color-black-transparent: rgba(0, 0, 0, 0.7);
		--color-black: #000;
		--color-white: #fff;

		--color-grey1: #ececec;
		--color-grey2: #e6e6e6;
		--color-grey3: #c6c6c6;
		--color-grey4: #939393;
		--color-grey5: #606060;
		--color-grey6: #313131;
		--color-grey7: #191919;

		--color-focus: #3E3EFF;
		--color-warn: #C00000;
		--color-ok: #247500;
		--color-warn-inverted: #ff0000;

		--color-background-widget: rgba(0, 0, 0, 0.4);
		--color-background-widget-active: #ffffff;
		--color-text-widget: #939393;
		--color-text-widget-active: #000;
		--border-widget: 1px solid #ffffff;
		--border-widget-active: 1px solid #ffffff;
		--border-radius-widget: 2px;
		--border-widget-fixed: 1px solid #939393;

		--border-desired: 1px dotted #2fa101;
		--border-conflict: 1px dotted #ff0000;

		--color-text-sections: #808080;
		--color-text-sections-active: #ffffff;
		--border-color-sections: #414141;
		--border-color-sections-satisfied: #949494;
		--border-color-sections-active: #d8d8d8;

		--color-widget-text: #ffffff;
		--color-widget-infoicon: #606060;
		--color-widget-border: #606060;
		--color-widget-text-disabled: #606060;
		--color-widget-border-light: #C6C6C6;

		--color-widget-info: #ffffff;

		--color-widget-background: #191919;
		--color-widget-background-hover: #313131;
		--color-widget-background-selected: #606060;
		--color-widget-background-implicit: #404040;
		--color-widget-background-selected-dark: #313131;
		--color-widget-background-light: #D9D9D9;
		--color-cta-button: rgba(62, 62, 255, 1)

	}
	.lightTheme {
		--color-black-transparent: rgba(255, 255, 255, 0.7);
		--color-black: #fff;
		--color-white: #000;

		--color-grey1: #191919;
		--color-grey2: #313131;
		--color-grey3: #606060;
		--color-grey4: #939393;
		--color-grey5: #c6c6c6;
		--color-grey6: #e6e6e6;
		--color-grey7: #ececec;

		--color-focus: #3E3EFF;
		--color-warn: #C00000;
		--color-ok: #247500;
		--border-desired: 1px dotted #2fa101;
		--border-conflict: 1px dotted #ff0000;

		--color-background-widget: rgba(255, 255, 255, 0.6);
		--color-background-widget-active: #000000;
		--color-text-widget: #6c6c6c;
		--color-text-widget-active: #ffffff;
		--border-widget: 1px solid #000000;
		--border-widget-active: 1px solid #000000;
		--border-widget-fixed: 1px solid #6c6c6c;

		--color-text-sections: #7f7f7f;
		--color-text-sections-active: #000000;
		--border-color-sections: #bebebe;
		--border-color-sections-satisfied: #6b6b6b;
		--border-color-sections-active: #272727;

		--specsheet-border: 0.25pt solid #575756;

		--color-widget-text: #000000;
		--color-widget-infoicon: #9f9f9f;
		--color-widget-border: #9f9f9f;
		--color-widget-text-disabled: #9f9f9f;
		--color-widget-border-light: #393939;

		--color-widget-info: #000000;

		--color-widget-background: #e6e6e6;
		--color-widget-background-hover: #cccccc;
		--color-widget-background-selected: #9f9f9f;
		--color-widget-background-implicit: #D0D0D0;
		--color-widget-background-selected-dark: #cccccc;
		--color-widget-background-light: #262626;
		--color-cta-button: rgba(62, 62, 255, 1)

	}
`;

export const sizes = css`
	:host {
		--header-height: 105px;
		--widget-max-width: 320px;
		--padding: 18px;
		--very-small-padding: 12px;
		--small-padding: 16px;
		--large-padding: 32px;
		--very-large-padding: 62px;
		--table-padding: 8px;

		--very-small-space: -32px;
		--medium-space: 14px;
		--large-space: 24px;

		--border-radius-widget: 2px;

		--arrows-width: 8px;
		--arrows-gap: 10px;

		--height-title: 32px;
		--font-size-widget: 15px;
		--font-size-widget-small: 13px;
		--font-size-widget-small-mono: 12px;

		--font-size-sections: 15px;

		--sections-gap: 9px;
		--sections-minwidth: 200px;
		--sections-progress-height: 48px;

		--tab-columns-small-width: 327px;
		--tab-columns-very-small-width: 288px;
		--column-gap: 20px;
		--column-min-width: 212px;


		--specsheet-minwidth: 230px;
		--specsheet-maxwidth: 1200px;

		--specsheet-feature-padding: 3px;
		--specsheet-featuregroup-gap: 25px;

		--specsheet-page-top-gap: 100px;
		--specsheet-page-side-gap: 125px;
		--specsheet-page-bottom-gap: 65px;
		--specsheet-large-gap: 80px;
		--specsheet-medium-gap: 40px;
		--specsheet-small-gap: 20px;

		--specsheet-print-large-gap: 8mm;
		--specsheet-print-medium-gap: 4mm;
		--specsheet-print-small-gap: 2mm;
		--specsheet-print-feature-padding: 1.15mm;


		--vertical-slider-number-element-height: 12px;
		--vertical-slider-major-numbers-left-indicator: 15px;
		--vertical-slider-major-numbers-left-padding: 17px;
		--vertical-slider-numbers-list-padding: 6px;
		--vertical-slider-min-height: 80px;
		--vertical-slider-width: 82px;
		--vertical-slider-arrow-width: 65px;

		--content-padding: 100px;

		--height-widget: 40px;

		--assistant-widget-width: 100%;

		--nav-button-tab-width: 40px;
		--nav-button-tab-height: 16px;
		--nav-button-height: 52px;
		--features-column-width: 360px;
		--features-column-gap: 48px;
	}
`;
